module.exports = __webpack_public_path__ + "media/images/shark/Heffalump-p-800-6c4b825bded98b13d99c3d9d53b0350e.jpeg";